import { SocialCounts } from '../models';
import { SocialRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetSocialCountsUseCase {
  constructor(private socialRepository: SocialRepository) {}

  async execute(userId: string): Promise<SocialCounts> {
    logger.debug('GetSocialCounts', 'Fetching social counts', { userId });

    const counts = await this.socialRepository.getCounts(userId);

    logger.debug('GetSocialCounts', 'Retrieved counts');

    return counts;
  }
}
